export function useEndpoints() {
	const endpoints = useAppConfig().hapiEndpoints;
	const nuxtApp = useNuxtApp();

	const get = endpoint => {
		const value = endpoint ? endpoints?.[endpoint] : endpoints;

		if (endpoint !== '_get_hapi_webshop_cart_full' || nuxtApp.$appGlobalData?.action !== 'review_order') {
			return value;
		}

		const [path, query] = value.split('?');
		const params = new URLSearchParams(query || '');
		params.set('payment_step', '1');

		return `${path}?${params.toString()}`;
	};

	return {endpoints, get};
}
